// Core
import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Flex, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useGLTF, Html, useProgress } from '@react-three/drei';
import { useSpring, animated } from '@react-spring/three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

// Components
import LoaderWithProgress from './LoaderWithProgress.js';

const ModelSetting = ({ modelPath, color, scale, progress }) => {
  const { scene } = useGLTF(modelPath);

  const props = useSpring({
    scale: [scale, scale, scale],
    config: { tension: 200, friction: 25 }, 
  });

  scene.traverse((child) => {
    if (child.isMesh) {
      child.material.metalness = 0.2;
      child.material.envMapIntensity = 0.1;
    }
  });

  const [isDelayFinished, setIsDelayFinished] = useState(false);

  return (
    <>
      <Suspense fallback={<LoaderWithProgress progress={progress} />}>
        <animated.primitive object={scene} scale={props.scale} />
      </Suspense>
    </>
  );
};

const Model = ({
  stationaryBoxRef,
  modelPositionX,
  modelPositionY,
  model3dX,
  models,
  activeModel,
  lightIntensity,
  lightPosition,
  progress,
  modelScale,
  setIsModelLoading,
  rotateModelScale
}) => {
  return (
    <Box className="model"
      mt="0">
      <Box w="40%" h="30px" bg="transparent" m="0 auto"
        ref={stationaryBoxRef}
        transform={`translateX(${modelPositionX}%) translateY(${modelPositionY}px)`}/>

      <Box transition="0.3s ease" w="400px" h="600px" mt={`${model3dX}px`}>
        <Canvas
          key={models[activeModel].name}
          camera={{
            position: models[activeModel].position,
            fov: 50,
          }}
        >
          <ambientLight intensity={0.6} color="#ffffff" />
          {lightIntensity > 0 && (
            <directionalLight position={lightPosition} intensity={lightIntensity} />
          )}
          <Suspense fallback={<LoaderWithProgress progress={progress} />}>
            <ModelSetting
              modelPath={models[activeModel].modelPath}
              scale={modelScale}
              progress={progress}
              setIsModelLoading={setIsModelLoading}
            />
          </Suspense>
          <OrbitControls 
            target={[rotateModelScale, 0.6, models[activeModel].target3]} 
            enableZoom={false} 
            enableRotate={false}  />
        </Canvas>
      </Box>
    </Box>
  )
}

export default Model;